/**
 * Per-page 新手 spotlight 導覽設定。
 * 每個 route 對應一組步驟：target 為頁面真實元素的 data-tour 選擇器，
 * titleKey / textKey 為 tutorial namespace 的 i18n key（由 TourController 用 t() 解析）。
 */
export interface TourStepConfig {
  target: string;
  titleKey: string;
  textKey: string;
}

// 共用收尾步驟：指向右上角聯絡 email icon（桌面版顯示；手機版隱藏時引擎會自動跳過）
const CONTACT_STEP: TourStepConfig = {
  target: '[data-tour="contact-email"]',
  titleKey: 'contact.title',
  textKey: 'contact.text',
};

export const PAGE_TOURS: Record<string, TourStepConfig[]> = {
  '/ai-chat': [
    {
      target: '[data-tour="chat-role"]',
      titleKey: 'aiChat.role1.title',
      textKey: 'aiChat.role1.text',
    },
    {
      target: '[data-tour="chat-role"]',
      titleKey: 'aiChat.role2.title',
      textKey: 'aiChat.role2.text',
    },
    {
      target: '[data-tour="chat-image"]',
      titleKey: 'aiChat.image.title',
      textKey: 'aiChat.image.text',
    },
    CONTACT_STEP,
  ],
  '/social-analysis': [
    {
      target: '[data-tour="analysis-platform"]',
      titleKey: 'analysis.platform.title',
      textKey: 'analysis.platform.text',
    },
    {
      target: '[data-tour="analysis-account"]',
      titleKey: 'analysis.account.title',
      textKey: 'analysis.account.text',
    },
    {
      target: '[data-tour="analysis-history"]',
      titleKey: 'analysis.history.title',
      textKey: 'analysis.history.text',
    },
    CONTACT_STEP,
  ],
  '/ai-publish': [
    {
      target: '[data-tour="publish-url"]',
      titleKey: 'publish.form.title',
      textKey: 'publish.form.text',
    },
    {
      target: '[data-tour="publish-tracked"]',
      titleKey: 'publish.tracked.title',
      textKey: 'publish.tracked.text',
    },
    {
      target: '[data-tour="publish-history"]',
      titleKey: 'publish.history.title',
      textKey: 'publish.history.text',
    },
    CONTACT_STEP,
  ],
};
